enum PageViewType {
  OnePage = 1,
  TwoPage = 2,
}

export const isLastPage = (currentPage: number, totalPages: number, firstPage: number): boolean => {
  return currentPage - firstPage === totalPages - 1;
};

export const isLastEvenPage = (
  currentPage: number,
  noOfPages: number,
  totalPages: number,
  firstPage: number
): boolean => {
  return (
    currentPage % 2 === 0 &&
    currentPage - firstPage === totalPages &&
    noOfPages === PageViewType.TwoPage
  );
};

export const hasNextPage = (
  currentPage: number,
  noOfPages: number,
  totalPages: number,
  firstPage: number
): boolean => {
  return currentPage - firstPage + noOfPages < totalPages;
};

export const hasPreviousPage = (currentPage: number, firstPage: number): boolean => {
  return currentPage > firstPage;
};

export const getTotalPages = (firstPage: number, lastPage: number): number =>
  lastPage - firstPage + 1;

export const isCoverPage = (hasCover: boolean, currentPage: number, firstPage: number) =>
  hasCover && currentPage === firstPage;

export const shouldDisplaySinglePage = (
  currentPage: number,
  noOfPages: number,
  totalPages: number,
  firstPage: number
) =>
  noOfPages === PageViewType.OnePage ||
  isLastEvenPage(currentPage, noOfPages, totalPages, firstPage);
